import React, { useState } from "react";
import ReactPlayer from 'react-player'

import iconPLay from "../../../assets/Vector (1).svg";
import thumIM from "../../../assets/Frame 427319600.png";

const VideoPlayer = ({ videoUrl }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    setIsPlaying(true);
  };

  return (
    <div style={styles.container} className="webSelfie">
      {!isPlaying ? (
          <div style={styles.thumbnailContainer} onClick={handlePlay}>
            <div style={styles.aspectWrapper}>
              <div style={styles.playerWrapper}>
                <ReactPlayer
                  url={videoUrl}
                  width="100%"
                  height="100%"
                  playing={false}
                  light={true}
                />
              </div>
            </div>
            <div style={styles.playButtonContainer}>
              <img src={iconPLay} alt="Play button" />
            </div>
          </div>
      ) : (
        <div style={styles.aspectWrapper}>
          <video
            controls
            style={styles.video}
            autoPlay
          >
            <source src={videoUrl} />
            Your browser does not support the video tag.
          </video>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    position: "relative",
    width: "100%",
    maxWidth: "100%",
    borderRadius: "10px",
    overflow: "hidden",
    boxSizing: "border-box",
  },
  thumbnailContainer: {
    position: "relative",
    cursor: "pointer",
    overflow: "hidden",
  },
  aspectWrapper: {
    width: "100%",
    position: "relative",
    paddingTop: "56.25%",
    borderRadius: "10px",
    overflow: "hidden",
    background: "#000"
  },
  playerWrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%"
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  videoHidden: {
    display: "none",
  },
  playButtonContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    cursor: "pointer",
    zIndex: 2
  },
  playButton: {
    width: "60px",
    height: "60px",
  },
  video: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "contain",
    background: "#000",
    borderRadius: "10px"
  },
};

export default VideoPlayer;
